import React from 'react'
import PageUnderConstruction from './PageUnderConstruction'

export default function FavoritePokemon() {
    return (
        <div data-testid = "favoritepokemon" className = "component-container">
            FavoritePokemon
            <PageUnderConstruction />
        </div>
    )
}
